import { useContext, useEffect, useMemo, useState } from "react"
import services from "../../../services/services";
import _ from "underscore";
import { Urls } from "../../../services/Urls";
import { ToastContext } from "../../../context/ToastContext";
import { dateHoverRange } from "../../../utils/Helper";

export const useTimesheetChart = ({ filterValues, setFilterValues, tab }) => {
    const { showInfo } = useContext(ToastContext);
    const [allCharts, setAllCharts] = useState([]);
    const [dataSetFlag, setDataSetFlag] = useState(false);
    const [chartOptions, setChartOptions] = useState({});

    // call api on filter change
    useEffect(() => {
        if (filterValues?.date?.[0] && filterValues?.date?.[1] && tab === "chart" && filterValues?.apiCall) {
            getManagerTimesheetChartSummary();
            setFilterValues((prev) => ({ ...prev, apiCall: false, isChange: false }));
        } else if (filterValues?.date?.[0] === undefined && filterValues?.date?.[1] === undefined && tab?.length !== 0) {
            showInfo("info", "Please select date");
        }
        // eslint-disable-next-line
    }, [filterValues?.apiCall, filterValues?.date])

    // get manager timesheet chart data
    const getManagerTimesheetChartSummary = async () => {
        setDataSetFlag(true);
        try {
            const start = (typeof filterValues?.date?.[0] === "string" ? filterValues?.date?.[0] : dateHoverRange(filterValues?.date?.[0])) || "";
            const end = (typeof filterValues?.date?.[1] === "string" ? filterValues?.date?.[1] : dateHoverRange(filterValues?.date?.[1])) || "";
            const payload = {
                "from_date": start || "",
                "to_date": end || "",
                "projects": _.pluck(filterValues?.projects, "project_id")?.toString() || "",
                "users": _.pluck(filterValues?.users, "user_code")?.toString() || "",
                "issueTypes": _.pluck(filterValues?.issue_type, "issue_type_id").toString() || "",
                "project_lead_user_code": _.pluck(filterValues?.project_leads, "user_code").toString(),
            }

            const res = await services.getInvokeRemote("POST", Urls("GETMANAGERTIMESHEETCHARTSUMMARY"), payload);
            if (res) {
                const data = res?.body?.data?.manager_Timesheet_Chart_Summary;
                const charts = _.uniq(_.pluck(data, "log_key"));
                let chartData = [];

                charts?.forEach((chart) => {
                    let obj = {};
                    obj["data"] = [];
                    const item = _.filter(data, { log_key: chart });
                    item?.forEach((i) => {
                        let data = {};
                        obj["chart_name"] = chart;
                        data["name"] = i.log_type;
                        data["y"] = parseFloat(i.logged_hours);
                        data["dataLabels"] = {
                            enabled: false,
                            format: '{point.name}',
                        };
                        obj["data"].push(data);
                    })
                    chartData.push(obj);
                })
                setAllCharts(chartData);
                setDataSetFlag(false);
                setAllOptions(chartData);
            }
        } catch (error) {
            console.error(error);
            setDataSetFlag(false);
        }
    }

    // set dynamic options of dynamic charts
    const setAllOptions = (data) => {
        let allOpt = {}
        data?.forEach(item => {
            const option = {
                credits: { enabled: false },
                chart: {
                    size: "86%",
                    plotBackgroundColor: null,
                    plotBorderWidth: null,
                    plotShadow: false,
                    type: "pie",
                },
                title: {
                    text: "",
                    align: "left",
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: "pointer",
                    },
                },
                series: [
                    {
                        name: item.chart_name,
                        colorByPoint: true,
                        data: item.data,
                        showInLegend: true,
                    },
                ],
                legend: {
                    size: "12px",
                    borderWidth: 0,
                    floating: 0,
                    layout: 'horizontal',
                    align: 'center',
                    verticalAlign: 'bottom',
                    x: 0,
                    y: 0,
                    labelFormatter: function () {
                        return this.name + " (" + (this.y) + "h)";
                    }
                }
            };

            allOpt[item.chart_name] = option
        })
        setChartOptions(allOpt);
    }

    return useMemo(() => ({
        dataSetFlag, allCharts, chartOptions
    }), [dataSetFlag, allCharts, chartOptions])
}